import React from 'react';

const Unauthorized = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-red-600">Unauthorized</h1>
        <p className="mt-4 text-gray-700">You are not authorized to access this page.</p>
      </div>
    </div>
  );
};

export default Unauthorized;